// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".author-share-links__wrapper[data-v-9394bce6]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;margin:20px 0}", ""]);
// Exports
module.exports = exports;
